import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["result", "statePanel", "field"]

  select(event) {
    const slug = event.target.value
    if (!slug) {
      this.resultTarget.classList.add("hidden")
      return
    }

    this.statePanelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.state !== slug)
    })
    this.resultTarget.classList.remove("hidden")
  }

  toggle(event) {
    if (this.hasFieldTarget) {
      if (event.target.checked) {
        this.fieldTarget.classList.remove("hidden")
      } else {
        this.fieldTarget.classList.add("hidden")
      }
    }
  }
}
